import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Tooltip } from "react-bootstrap";
import { Tabs } from "antd";
import Suppliers from "./suppliers";
import Warehouses from "./warehouses";
import { getProfileTest } from "../../core/api/auth";
import ProductOrdersList from "./ProductOrdersList";
import PrintOrdersList from "./PrintOrdersList";
import ListOrdersList from "./ListOrdersList";

const { TabPane } = Tabs;
const OrdersList = () => {
  const data = useSelector((state) => state.toggle_header);
  const location = useLocation();
  const navigate = useNavigate();

  const tabKeyToPath = {
    1: "product-orders",
    2: "print-orders",
    3: "list-orders",
    4: "suppliers",
    5: "warehouses",
  };

  const pathToTabKey = Object.entries(tabKeyToPath).reduce(
    (acc, [key, path]) => {
      acc[path] = key;
      return acc;
    },
    {}
  );

  const currentTab = location.pathname.split("/")[2];
  const activeTabKey = pathToTabKey[currentTab] || "1";
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  
  return (
    <div className="page-wrapper">
      <Tabs
        activeKey={activeTabKey}
        onChange={(key) => navigate(`/order-list/${tabKeyToPath[key]}`)}
        className="p-2"
        type="card"
        size="small"
      >
        <TabPane tab="Product Orders" key="1">
          <ProductOrdersList/>
        </TabPane>
        <TabPane tab="Print Orders" key="2">
          <PrintOrdersList/>
        </TabPane>
        <TabPane tab="List Orders" key="3">
          <ListOrdersList/>
        </TabPane>
        <TabPane tab="Warehouses" key="5">
          <Warehouses />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default OrdersList;
